import { Wrapper, Title, Content, ButtonGroup } from './styles'
import { DialogProps } from './types'

function Dialog({ title = '', message = '', buttons, children }: DialogProps) {
  return (
    <Wrapper>
      <Title>{title}</Title>
      {message && <Content>{message}</Content>}
      {children}
      {buttons && (
        <ButtonGroup>
          <button onClick={buttons.onSuccess.handle} type="button">
            {buttons.onSuccess.name}
          </button>
          <button onClick={buttons.onFailure.handle} type="button">
            {buttons.onFailure.name}
          </button>
        </ButtonGroup>
      )}
    </Wrapper>
  )
}
export default Dialog
